import React from 'react';
import { useState } from 'react';
import './Navbar.css';
import ReactSearchBox from 'react-search-box';
import axios from '../../axios'




function Navbar(props) {
  const [movies,setMovies]=useState([])


  const Handle =()=>{
    axios.get(props.url).then((response)=>{
      setMovies(response.data.results)
    })
  }

  const HandleContact=()=>{
    
    alert("Contact us through dondonbos828@gmail.com");

  }




  return (
    
    <div className='navbar'>
      <img className='logo' src="https://upload.wikimedia.org/wikipedia/commons/thumb/0/08/Netflix_2015_logo.svg/1920px-Netflix_2015_logo.svg.png" alt="Netflix Logo" />
     
      <button className='avatar' onClick={HandleContact} >Contact</button>

      <div className='all'>
        <button className='text'>Home</button>
        <button className='text1'>TV Shows</button>
        <button className='text2'>Movies</button>
        <button className='text3'>New & Popular</button>
        <button className='text4'>My List</button>
        <button className='text5'>Browse by Language</button>
        <h1 className='search'>

          {movies.map((obj)=>{
            return(
              <ReactSearchBox
              data={Handle}
              onSelect={obj}
  
              inputBorderColor='lightblue' inputFontColor='white' inputBackgroundColor='black' placeholder="Search..."
      
            />
              
            )

          })}




      </h1>

      </div>


    </div>
  );
}

export default Navbar;
